import React from 'react'

const Contact = () => {
  return (
    <div name='contact' className='w-full h-screen bg-[#FFFFFF] flex justify-center items-center p-4'>
        <form method='POST' action="https://getform.io/f/a92317be-4b7c-4921-b0c1-0069079657b3" className='flex flex-col max-w-[600px] w-full'>
            <div className='pb-8'>
                <p className='text-4xl font-bold inline border-b-4 border-pink-600 text-black-300'>Contact</p>
                <p className='text-bold text-black-300 py-4'>// Submit the form below or shoot me an email - myemail@gmail.com</p>
                <p className='text-bold text-black-300 '>// feel free to contact on my email - abhimanpratap340@gmail.com</p>
            </div>
            <input className='bg-[#ccd6f6] p-2' type="text" placeholder='Name' name='name' />
            <input className='my-4 p-2 bg-[#ccd6f6]' type="email" placeholder='Email' name='email' />
            <textarea className='bg-[#ccd6f6] p-2' name="message" rows="10" placeholder='Message'></textarea>
            <button className='border-black  text-black border-4 hover:bg-pink-600 hover:border-pink-600 px-4 py-3 my-8 mx-auto flex items-center'>Let's Collaborate</button>
        </form>
    </div>
  )
}

export default Contact